module.exports = __webpack_public_path__ + "img/FrontProduct.ff4c75f0.png";